import { StoreState } from 'src/store/reducers';
import { createSelector } from 'reselect';
import Router from '../../navigation/router';
import { routes } from '../../navigation';
import user from '../../services/user-auth';
import UserRole from '../../enumerables/user-role';
import { IProvider } from '../../types/provider';
import {
    faEdit,
    faHourglassHalf,
    IconDefinition,
    faHistory,
    faMoneyCheckAlt,
    faCalendarCheck,
    faFileImport,
    faFileContract,
    faClock,
    faFlagCheckered,
    faUser,
    faUsers,
} from '@fortawesome/free-solid-svg-icons';
import { numberWithCommas } from '../../helpers/format';

const getListDashboard = (state: StoreState) => {
    const dataDashboard = state.app.dashBoardData;
    const dataUser: Partial<IProvider> = state.auth.data;
    const dataResult: InfoObjectLink[] = [];

    let types: {
        [key: string]: Partial<{ label: string; link: string; id: string; icon: IconDefinition; order: number }>;
    } = {};
    if (user.getRoles().includes(UserRole.ROLE_ADMIN)) {
        types = {
            notUploadedInvoices: {
                label: 'Awaiting Signatures',
                link: Router.generate(routes.INVOICES_LIST, { status: 1 }),
                icon: faFileImport,
                order: 1,
            },
            ivoiceToBeApproved: {
                label: 'Awaiting Approval',
                link: Router.generate(routes.INVOICE_DOCS_LIST),
                icon: faHourglassHalf,
                order: 2,
            },
            seanceWaitingDataSheet: {
                label: 'Awaiting Program Book',
                link: Router.generate(routes.SEANCES_LIST, { status: 4, datasheet: 3 }),
                icon: faClock,
                order: 3,
            },
            caseWithoutConsent: {
                label: 'Awaiting Consent',
                link: Router.generate(routes.CASES_NO_CONSENTS_LIST),
                icon: faFileContract,
                order: 4,
            },
            caseWithoutPrincipal: {
                label: 'Awaiting Principal',
                link: Router.generate(routes.CASES_NO_PRINCIPALS_LIST),
                icon: faUser,
                order: 5,
            },
            casesMissingInfo: {
                label: 'Cases Missing Info',
                link: Router.generate(routes.CASES_LIST, { status: 3 }),
                icon: faEdit,
                order: 6,
            },
            ordersMissingInfo: {
                label: 'Orders Missing Info',
                link: Router.generate(routes.ORDERS_LIST, { status: 3 }),
                icon: faEdit,
                order: 7,
            },
            unconfirmedSessions: {
                label: 'Unconfirmed Sessions',
                link: Router.generate(routes.SEANCES_LIST, { status: 3, datasheet: 'all' }),
                icon: faCalendarCheck,
                order: 8,
            },
            remainHoursOfOrders: {
                label: 'Orders Remaining Hours',
                link: Router.generate(routes.ORDER_REMAINING_HOURS_REPORTS_LIST),
                icon: faHourglassHalf,
                order: 9,
            },
            confirmedAmount: {
                label: 'Confirmed Amount',
                link: Router.generate(routes.PROVIDER_REPORTS_LIST),
                icon: faMoneyCheckAlt,
                order: 10,
            },
            expiredOrders: {
                label: 'Expiring Orders',
                link: Router.generate(routes.ORDER_EXPIRED_REPORTS_LIST),
                icon: faHistory,
                order: 11,
            },
            casesEvaluationCompleted: {
                label: 'Completed Evaluations',
                link: Router.generate(routes.CASES_LIST, { status: 1, completed: 1 }),
                icon: faFlagCheckered,
                order: 12,
            },
            caseActive: {
                label: 'Active Cases',
                link: Router.generate(routes.CASES_LIST, { seanceActive: 30 }),
                icon: faFileContract,
                order: 13,
            },
            studentActive: {
                label: 'Active Students',
                link: Router.generate(routes.STUDENTS_LIST, { seanceActive: 30 }),
                icon: faUsers,
                order: 14,
            },
            duePayment: {
                label: 'Due Payment',
                link: Router.generate(routes.INVOICES_LIST, { status: 4 }),
                icon: faFileImport,
                order: 15,
            },
        };
    }
    if (!user.getRoles().includes(UserRole.ROLE_ADMIN) && dataUser.userProviders && dataUser.userProviders.length) {
        types = {
            remainHoursOfOrders: {
                label: 'Orders Remaining Hours',
                link: Router.generate(routes.ORDER_REMAINING_HOURS_REPORTS_LIST),
                icon: faHourglassHalf,
                order: 1,
            },
            unconfirmedSessions: {
                label: 'Unconfirmed Sessions',
                icon: faCalendarCheck,
                link: Router.generate(routes.SEANCES_LIST, { status: 3, datasheet: 'all' }),
                order: 2,
            },
            notUploadedInvoices: {
                label: 'Invoices Awaiting Signatures',
                icon: faFileImport,
                link: Router.generate(routes.INVOICES_LIST, { status: 1 }),
                order: 3,
            },
            seanceWaitingDataSheet: {
                label: 'Awaiting Program Book',
                link: Router.generate(routes.SEANCES_LIST, { status: 4, datasheet: 3 }),
                icon: faClock,
                order: 4,
            },
            expiredOrders: {
                label: 'Expiring Orders',
                link: Router.generate(routes.ORDER_EXPIRED_REPORTS_LIST),
                icon: faHistory,
                order: 5,
            },
            //   hoursWorked: { label: 'Hours Worked', link: Router.generate(routes.PROVIDER_REPORTS_LIST) },
            /*confirmedAmount: {
                label: 'Confirmed Amount',
                link: Router.generate(routes.PROVIDER_REPORTS_LIST),
                icon: faMoneyCheckAlt,
                order: 3,
            },*/
            caseWithoutConsent: {
                label: 'Cases Without Consent',
                link: Router.generate(routes.CASES_NO_CONSENTS_LIST),
                icon: faFileContract,
                order: 6,
            },
        };
    } else if (
        !user.getRoles().includes(UserRole.ROLE_ADMIN) &&
        dataUser.userProviders &&
        !dataUser.userProviders.length
    ) {
        types = {
            remainHoursOfOrders: {
                label: 'Orders Remaining Hours',
                link: Router.generate(routes.ORDER_REMAINING_HOURS_REPORTS_LIST),
                icon: faHourglassHalf,
                order: 1,
            },
            unconfirmedSessions: {
                label: 'Unconfirmed Sessions',
                icon: faCalendarCheck,
                link: Router.generate(routes.SEANCES_LIST, { status: 3, datasheet: 'all' }),
                order: 2,
            },
            notUploadedInvoices: {
                label: 'Invoices Awaiting Signatures',
                icon: faFileImport,
                link: Router.generate(routes.INVOICES_LIST, { status: 1 }),
                order: 3,
            },
            seanceWaitingDataSheet: {
                label: 'Awaiting Program Book',
                link: Router.generate(routes.SEANCES_LIST, { status: 4, datasheet: 3 }),
                icon: faClock,
                order: 4,
            },
            expiredOrders: {
                label: 'Expiring Orders',
                link: Router.generate(routes.ORDER_EXPIRED_REPORTS_LIST),
                icon: faHistory,
                order: 5,
            },
            //   hoursWorked: { label: 'Hours Worked', link: Router.generate(routes.PROVIDER_REPORTS_LIST) },
            caseWithoutConsent: {
                label: 'Case Without Consent',
                link: Router.generate(routes.CASES_NO_CONSENTS_LIST),
                icon: faFileContract,
                order: 6,
            },
        };
    }

    Object.keys(dataDashboard).forEach((it: string | number, i) => {
        if (types[it]) {
            if (`${it}` === 'confirmedAmount' || `${it}` === 'remainHoursOfOrders' || `${it}` === 'duePayment') {
                dataResult.push({
                    value: dataDashboard[it] ? numberWithCommas(dataDashboard[it]) : 0,
                    label: `${types[it].label}`,
                    link: `${types[it].link}`,
                    id: `${it}`,
                    icon: types[it].icon,
                    order: +`${types[it].order}`,
                });
            } else {
                dataResult.push({
                    value: dataDashboard[it] ? dataDashboard[it] : 0,
                    label: `${types[it].label}`,
                    link: `${types[it].link}`,
                    id: `${it}`,
                    icon: types[it].icon,
                    order: +`${types[it].order}`,
                });
            }
        }
    });
    return dataResult;
};
export const selectDashboardData = createSelector(getListDashboard, (items): InfoObjectLink[] => {
    return items;
});
